export const isAbortOrNetworkError = (e) => {
  // 모바일 사파리: 백그라운드 전환 시 fetch가 Abort 또는 TypeError(NetworkError)로 떨어짐
  return (
    (e instanceof DOMException && e.name === 'AbortError') ||
    e instanceof TypeError
  )
}

export const safeParseJson = async (res) => {
  try {
    return await res.clone().json();
  } catch {
    try {
      return await res.clone().text();
    } catch {
      return undefined;
    }
  }
}

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms))